export const BASE_URL = '';
/** 统一前缀 */
export const API_URL = `${BASE_URL}/api`;
// login
export const LOGIN_URL = `${API_URL}/login/web`;
// dict
export const DICT_URL = `${API_URL}/dict/web`;
// data
export const DATA_URL = `${BASE_URL}/data`;
// oss
export const OSS_URL = `${API_URL}/oss`;
// user
export const USER_URL = `${API_URL}/user`;
